import HeroFamily from 'images/custom/images/login/eh-login@2x.png'

const themeStyles = colors => {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'center',
      width: '100%',
      borderRadius: '4px',
      backgroundColor: colors.white,
      boxShadow: '0 5px 10px 0 rgba(0,0,0,0.06)'
    },
    verticalLogoContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: 60,
      width: 150
    },
    imageContainer: {
      position: 'relative',
      height: 280
    },
    heroImagePlug: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
    },
    heroImage: {
      width: '100%',
      height: 280,
      objectFit: 'cover',
      objectPosition: 'center'
    },
    image: {
      height: '100%',
      backgroundSize: 'cover',
      backgroundImage: `url(${HeroFamily})`
    },
    childContainer: {
      padding: '19px 72px 25px 72px'
    },
    childContainerVertical: {
      padding: '0 20px 29px 20px'
    },
    footer: {
      container: {
        height: '72px'
      }
    },
    logo: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 138,
      height: 47,
      objectFit: 'contain'
    }
  }
  return styles
}

export default themeStyles
